export function getTrialRenewalDate(leadTime: number) {
  const date = new Date();
  date.setTime(date.getTime() + 86400000 * leadTime);
  const renewalMonth = date.toLocaleDateString(undefined, {
    month: 'short',
  });
  return renewalMonth + ' ' + date.getDate() + ', ' + date.getFullYear();
}
